import { render, staticRenderFns } from "./InstagramIcon.vue?vue&type=template&id=1233099a&scoped=true"
import script from "./InstagramIcon.vue?vue&type=script&lang=js"
export * from "./InstagramIcon.vue?vue&type=script&lang=js"
import style0 from "./InstagramIcon.vue?vue&type=style&index=0&id=1233099a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233099a",
  null
  
)

export default component.exports